import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ResponseGetBotInterface } from '../../../../models/bot.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { BotService } from '../../../../core/services/bot.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { Tooltip } from 'primeng/tooltip';
import { GlobalObservableService } from 'src/app/core/services/global-observable.service';

@Component({
  selector: 'globot-embed-html',
  template: `
    <ng-container *ngIf="!isMobile; else mobile">
      <div class="embed">
        <p>1. Copia el siguiente código:</p>
        <pre style="margin: 0; position: relative;">
            <code>&lt;script src="{{ route }}" type="text/javascript" defer=""&gt;&lt;/script&gt;
                &lt;script defer=""&gt;{{ codeJS }}&lt;/script&gt;
            </code>
            <i class="pi pi-copy" (click)="copyCodeToClipboard()" pTooltip="¡Copiado!" tooltipPosition="top" [life]="2000" tooltipEvent="focus"></i>
        </pre>
        <p>
          2. Pega el código en tu index.html antes del &lt;body&gt;, haz esto en la página que
          desees que se muestre el asistente.
        </p>

        <p>3. ¡Listo! tu asistente se encuentra listo para interactuar.</p>
      </div>
    </ng-container>
    <ng-template #mobile>
      <div class="grid" style="width:80vw">
        <div class="col">
          <p>1. Copia el siguiente codigo:</p>
        </div>
        <div class="copy">
          <div class="col cod">
            <code>
              &lt;script src="{{ route }}" type="text/javascript" defer=""&gt;&lt;/script&gt;
              &lt;script defer=""&gt;{{ codeJS }}
              &lt;/script&gt;
            </code>
          </div>
          <div class="icon">
            <i class="pi pi-copy" (click)="copyCodeToClipboard()"></i>
          </div>
        </div>
        <div class="col">
          <p>
            2. Pega el código en tu <strong>index.html</strong> antes de
            <strong>&lt;/body&gt;</strong>, haz esto en la página que desees que se muestre el
            asistente.
          </p>
        </div>
        <div class="col">
          <p>
            3. <strong>¡Listo!</strong>Tu asistente se encontrará disponible para interactuar en la
            esquina inferior derecha de tu sitio.
          </p>
        </div>
      </div>
    </ng-template>
  `,
  styleUrls: ['./embed-html.component.scss'],
})
export class EmbedHtmlComponent implements OnInit {
  @Input() bot: ResponseGetBotInterface | undefined;
  @ViewChild(Tooltip) tooltip!: Tooltip;

  codeJS: string =
    "document.addEventListener('DOMContentLoaded', function () {\n" +
    '    var host = window.location.host; \n' +
    '    var chatConfig = {\n' +
    '    \thost: host,\n' +
    '    };\n' +
    '    initializeChatWidget(chatConfig);\n' +
    '});';

  isMobile = false;
  route: string = 'https://app.globot.ai/assets/chat.js';

  constructor(
    private aRoute: ActivatedRoute,
    private router: Router,
    private botService: BotService,
    private clipboard: Clipboard,
    private globalObservable: GlobalObservableService
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 768;

    if (
      window.location.href.includes('localhost') ||
      window.location.href.includes('127.0.0.1') ||
      window.location.href.includes('backoffice-dev') ||
      window.location.href.includes('app-dev')
    ) {
      this.route = 'https://app-dev.globot.ai/assets/chat-dev.js';
    }

    if (window.location.href.includes('backoffice-qa')) {
      this.route = 'https://backoffice-qa.globot.ai/assets/chat-qa.js';
    }
    this.getCodeJs();
  }

  getCodeJs() {
    this.codeJS = "\ndocument.addEventListener('DOMContentLoaded', function () {\n";
    this.codeJS += '\tvar chatConfig = {\n';
    this.codeJS += '\t\ttoken: "' + this.bot?.token + '",\n';
    this.codeJS += '\t\tbotId: "' + this.bot?.id + '",\n';
    this.codeJS += '\t};\n';
    this.codeJS += '\tinitializeChatWidget(chatConfig);\n';
    this.codeJS += '});\n';
  }

  copyCodeToClipboard() {
    const code = `<script src="${this.route}" type="text/javascript" defer=""></script>
                  <script defer="">
  ${this.codeJS}
  </script>`;
    this.clipboard.copy(code);
    this.tooltip.activate();
  }
}
